import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import Card from "../common/card";
import "./styles/works.css";

const Works = () => {
  return (
    <div className="works">
      <Card
        icon={faBriefcase}
        title="Professional Journey"
        body={
          <div className="works-body">
            {/* Freelance Experience */}
            <div className="work">
              <img
                src="./veltex-systems-logo-square.jpg"
                alt="Full Stack Developer"
                className="work-image"
              />
              <div className="work-title">Veltex Systems</div>
              <div className="work-subtitle">
                Full-Stack Developer
              </div>
              <div className="work-duration">2026 - Present</div>
            </div>

            {/* Freelance Experience */}
            <div className="work">
              <img
                src="./kirunda-logo.jpg"
                alt="Freelance Developer"
                className="work-image"
              />
              <div className="work-title">Independent Developer & Consultant</div>
              <div className="work-subtitle">
                Full-Stack Specialist
              </div>
              <div className="work-duration">2020 - Present</div>
            </div>

            {/* Tech Company Experience */}
            <div className="work">
              <img
                src="./ubunifu-logo.jpg"
                alt="Ubunifu Systems"
                className="work-image"
              />
              <div className="work-title">Ubunifu Systems</div>
              <div className="work-subtitle">
                Senior Full-Stack Developer
              </div>
              <div className="work-duration">2018 - 2020</div>
            </div>

            {/* Startup Experience */}
            <div className="work">
              <img
                src="./prowebin-logo.jpg"
                alt="Prowebin Limited"
                className="work-image"
              />
              <div className="work-title">Prowebin Limited</div>
              <div className="work-subtitle">
                JavaScript Developer
              </div>
              <div className="work-duration">2016 - 2018</div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Works;